export default class PullReaponseParser {
    static process(clientStater, msg) {
        clientStater.dispatch(msg.refGuid, msg);
    }
}
//# sourceMappingURL=pullReaponseParser.js.map